export enum InvoiceStatusEnum {
  PENDING = "PENDING",
  VALIDATED = "VALIDATED",
  BLOCKED = "BLOCKED",
  DELETED = "DELETED",
}
